// =============================================================================
// CHAT PROFILE PANEL — In-chat profile editor
// Tabs: Profile, Profile Pic, Subscriptions
// Depends on: mhv-config.js (MHV.SERVER_URL, MHV.escapeHtml), mhv-fetch.js (mhvFetch)
// =============================================================================

(function() {
  'use strict';

  var SERVER = (window.MHV && MHV.SERVER_URL) || '';
  var panel = null;
  var activeTab = 'profile';
  var profileData = null;  // cached customer-details response
  var marketingData = null; // cached marketing-status response
  var savedProfile = {};    // snapshot for dirty detection
  var currentProfilePic = '';
  var lightboxOpen = false;
  var previousHistoryState = null;

  // Avatar presets — same as account page (mhv-account.liquid)
  var AVATAR_GROUPS = [
    { title: 'MHV Moods', pics: [
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-happy.png?v=1765446700', name: 'Happy' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-sultry.png?v=1765446700', name: 'Sultry' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-cheeky.png?v=1765446700', name: 'Cheeky' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-bummed.png?v=1765446700', name: 'Bummed' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-wacky.png?v=1765446700', name: 'Wacky' },
    ]},
    { title: 'The 20th Century', pics: [
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1900.png?v=1765446700', name: '1900' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1910.png?v=1765446700', name: '1910' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1920.png?v=1765446700', name: '1920' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1930.png?v=1765446700', name: '1930' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1940.png?v=1765446700', name: '1940' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1950.png?v=1765446700', name: '1950' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1960.png?v=1765446700', name: '1960' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1970.png?v=1765446700', name: '1970' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1980.png?v=1765446700', name: '1980' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-1990.png?v=1765446701', name: '1990' },
    ]},
    { title: "Spotty's Adventures", pics: [
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-space-spot.png?v=1765448222', name: 'SpaceSpot' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-cowboy-spot.png?v=1765448087', name: 'CowboySpot' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-super-spot.png?v=1765448087', name: 'SuperSpot' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-sailor-spot.png?v=1765448087', name: 'SailorSpot' },
      { url: 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-vampa-spot.png?v=1765448087', name: 'VampaSpot' },
    ]},
  ];

  var MARKETPLACE_PLATFORMS = [
    { key: 'whatnot', label: 'Whatnot', type: 'username', prefix: '@', placeholder: 'your-username', domain: 'whatnot.com' },
    { key: 'instagram', label: 'Instagram', type: 'username', prefix: '@', placeholder: 'your-username', domain: 'instagram.com' },
    { key: 'facebook', label: 'Facebook', type: 'url', placeholder: 'https://www.facebook.com/yourname', domain: 'facebook.com' },
    { key: 'ebay', label: 'eBay', type: 'url', placeholder: 'https://www.ebay.com/usr/...', domain: 'ebay.com' },
    { key: 'etsy', label: 'Etsy', type: 'url', placeholder: 'https://www.etsy.com/shop/...', domain: 'etsy.com' },
    { key: 'liveauctioneers', label: 'LiveAuctioneers', type: 'url', placeholder: 'https://www.liveauctioneers.com/...', domain: 'liveauctioneers.com' },
    { key: 'auctionzip', label: 'AuctionZip', type: 'url', placeholder: 'https://www.auctionzip.com/...', domain: 'auctionzip.com' },
    { key: 'website', label: 'Website', type: 'url', placeholder: 'https://www.yoursite.com', domain: null },
  ];

  var SMS_NUMBER = '(855) 505-2016';
  var SMS_NUMBER_RAW = '+18555052016';

  // --- Helpers ---
  function esc(str) { return MHV.escapeAttr(str || ''); }

  function getEmail() {
    var c = document.querySelector('.custom-chat-container');
    return c ? c.dataset.customerEmail : '';
  }

  function showToast(msg) {
    var t = panel && panel.querySelector('.cpp-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('visible');
    setTimeout(function() { t.classList.remove('visible'); }, 2000);
  }

  function getMarketplaceIcon(domain) {
    if (!domain) return '<svg class="cpp-link-icon" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="6" fill="#4A90D9"/><circle cx="12" cy="12" r="5.5" stroke="#fff" stroke-width="1.5" fill="none"/><ellipse cx="12" cy="12" rx="2.5" ry="5.5" stroke="#fff" stroke-width="1.2" fill="none"/><line x1="6.5" y1="12" x2="17.5" y2="12" stroke="#fff" stroke-width="1.2"/></svg>';
    return '<img class="cpp-link-icon" src="https://www.google.com/s2/favicons?domain=' + domain + '&sz=128" alt="">';
  }

  // =========================================================================
  // PANEL CREATION
  // =========================================================================
  function createPanel() {
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'chat-profile-lightbox';
    panel.onclick = function(e) { if (e.target === panel) closeChatProfilePanel(); };
    panel.innerHTML =
      '<div class="cpp-content">' +
        '<div class="cpp-header">' +
          '<span class="cpp-header-title">My Profile</span>' +
          '<span class="cpp-unsaved-badge" id="cpp-unsaved-badge" style="display:none;">Unsaved</span>' +
          '<button class="cpp-close-btn" onclick="closeChatProfilePanel()">&times;</button>' +
        '</div>' +
        '<div class="cpp-tabs">' +
          '<button class="cpp-tab active" data-tab="profile">Profile</button>' +
          '<button class="cpp-tab" data-tab="pic">Profile Pic</button>' +
          '<button class="cpp-tab" data-tab="subs">Subscriptions</button>' +
        '</div>' +
        '<div class="cpp-body" id="cpp-body"></div>' +
        '<div class="cpp-footer">' +
          '<span class="cpp-footer-close" onclick="closeChatProfilePanel()">&times; CLOSE</span>' +
        '</div>' +
      '</div>' +
      '<div class="cpp-toast"></div>';

    document.body.appendChild(panel);

    // Tab switching
    panel.querySelectorAll('.cpp-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var t = this.dataset.tab;
        if (t === activeTab) return;
        activeTab = t;
        panel.querySelectorAll('.cpp-tab').forEach(function(x) { x.classList.toggle('active', x.dataset.tab === t); });
        renderActiveTab();
      });
    });

    return panel;
  }

  // =========================================================================
  // DATA LOADING
  // =========================================================================
  function loadProfileData(cb) {
    var email = getEmail();
    if (!email) return cb && cb();

    var fetchFn = window.mhvFetch || fetch;
    fetchFn(SERVER + '/customer-details/' + encodeURIComponent(email), {}, { useCache: false })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success && data.customer) {
          profileData = data.customer;
          currentProfilePic = profileData.profile_image || profileData.metafields?.profile_image || '';
          savedProfile = {
            screen_name: profileData.screen_name || profileData.metafields?.screen_name_cc || '',
            hide_name: !!profileData.hide_name,
            bio: profileData.bio || '',
            marketplace_links: profileData.marketplace_links || {},
          };
        }
        if (cb) cb();
      })
      .catch(function(err) {
        console.error('Chat profile: error loading profile', err);
        if (cb) cb();
      });
  }

  function loadMarketingData(cb) {
    var email = getEmail();
    if (!email) return cb && cb();

    var fetchFn = window.mhvFetch || fetch;
    fetchFn(SERVER + '/marketing-status/' + encodeURIComponent(email), {}, { useCache: false })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) marketingData = data;
        if (cb) cb();
      })
      .catch(function(err) {
        console.error('Chat profile: error loading marketing', err);
        if (cb) cb();
      });
  }

  // =========================================================================
  // TAB RENDERING
  // =========================================================================
  function renderActiveTab() {
    var body = panel && panel.querySelector('#cpp-body');
    if (!body) return;

    if (activeTab === 'profile') renderProfileTab(body);
    else if (activeTab === 'pic') renderPicTab(body);
    else if (activeTab === 'subs') renderSubsTab(body);
  }

  // --- PROFILE TAB ---
  function renderProfileTab(body) {
    if (!profileData) {
      body.innerHTML = '<p style="color:var(--mhv-text-subtle);text-align:center;padding:20px;">Loading...</p>';
      return;
    }

    var container = document.querySelector('.custom-chat-container');
    var firstName = container ? (container.dataset.customerFirstName || '') : '';
    var lastName = container ? (container.dataset.customerLastName || '') : '';
    var namePreview = MHV.realName(firstName, lastName) || '(your name)';
    var bidderNumber = container ? (container.dataset.customerBidderNumber || '') : '';

    var linksHtml = MARKETPLACE_PLATFORMS.map(function(p) {
      var val = (savedProfile.marketplace_links && savedProfile.marketplace_links[p.key]) || '';
      var icon = getMarketplaceIcon(p.domain);

      if (p.type === 'username') {
        return '<div class="cpp-link-row">' + icon +
          '<div class="cpp-username-group">' +
            '<span class="cpp-username-prefix">' + p.prefix + '</span>' +
            '<input type="text" class="cpp-input cpp-link-input cpp-username-input" ' +
              'id="cpp-link-' + p.key + '" ' +
              'placeholder="' + esc(p.placeholder) + '" ' +
              'value="' + esc(val) + '" ' +
              'maxlength="60" oninput="window._cppCheckDirty && _cppCheckDirty()">' +
          '</div></div>';
      }
      return '<div class="cpp-link-row">' + icon +
        '<input type="url" class="cpp-input cpp-link-input" ' +
          'id="cpp-link-' + p.key + '" ' +
          'placeholder="' + esc(p.placeholder) + '" ' +
          'value="' + esc(val) + '" ' +
          'maxlength="200" oninput="window._cppCheckDirty && _cppCheckDirty()">' +
        '</div>';
    }).join('');

    body.innerHTML =
      // Bidder number badge
      (bidderNumber ? '<div style="margin-bottom:12px;"><span style="display:inline-block;background:rgba(var(--mhv-accent-rgb),0.15);color:var(--mhv-accent);padding:3px 10px;border-radius:12px;font-size:12px;font-weight:700;">#' + esc(bidderNumber) + '</span></div>' : '') +

      // Screen name (optional)
      '<div class="cpp-field">' +
        '<label class="cpp-label">Screen Name <span style="font-weight:400;opacity:0.6;">(optional)</span></label>' +
        '<input type="text" class="cpp-input" id="cpp-screen-name" ' +
          'value="' + esc(savedProfile.screen_name) + '" ' +
          'placeholder="Optional — pick a display name" ' +
          'maxlength="25" oninput="window._cppCheckDirty && _cppCheckDirty()">' +
      '</div>' +

      // Hide name toggle (real name shown by default)
      '<div class="cpp-field">' +
        '<div class="cpp-toggle-row">' +
          '<div>' +
            '<div class="cpp-toggle-label">Hide my name in chat</div>' +
            '<div class="cpp-toggle-sublabel">By default others see <strong>' + esc(namePreview) + '</strong>. Turn on to hide your name.</div>' +
          '</div>' +
          '<label class="cpp-toggle">' +
            '<input type="checkbox" id="cpp-hide-name" ' + (savedProfile.hide_name ? 'checked' : '') + ' onchange="window._cppCheckDirty && _cppCheckDirty()">' +
            '<span class="cpp-toggle-slider"></span>' +
          '</label>' +
        '</div>' +
      '</div>' +

      // Bio
      '<div class="cpp-field">' +
        '<label class="cpp-label">Bio</label>' +
        '<textarea class="cpp-input cpp-textarea" id="cpp-bio" maxlength="250" ' +
          'placeholder="Tell people a little about yourself..." ' +
          'oninput="window._cppUpdateBioCount && _cppUpdateBioCount(); window._cppCheckDirty && _cppCheckDirty()">' + esc(savedProfile.bio) + '</textarea>' +
        '<div class="cpp-char-count" id="cpp-bio-count">' + (savedProfile.bio || '').length + '/250</div>' +
      '</div>' +

      // Links
      '<div class="cpp-field">' +
        '<label class="cpp-label">Links</label>' +
        linksHtml +
      '</div>' +

      // Save
      '<button class="cpp-save-btn disabled" id="cpp-profile-save" onclick="window._cppSaveProfile && _cppSaveProfile()">Save</button>';
  }

  // Bio char counter
  window._cppUpdateBioCount = function() {
    var bio = document.getElementById('cpp-bio');
    var counter = document.getElementById('cpp-bio-count');
    if (!bio || !counter) return;
    var len = bio.value.length;
    counter.textContent = len + '/250';
    counter.className = 'cpp-char-count' + (len >= 240 ? ' at-limit' : len >= 200 ? ' near-limit' : '');
  };

  // Dirty detection
  window._cppCheckDirty = function() {
    var current = getCurrentProfileValues();
    var dirty = current.screen_name !== savedProfile.screen_name ||
                current.hide_name !== savedProfile.hide_name ||
                current.bio !== (savedProfile.bio || '') ||
                JSON.stringify(current.marketplace_links) !== JSON.stringify(savedProfile.marketplace_links || {});
    var btn = document.getElementById('cpp-profile-save');
    var badge = document.getElementById('cpp-unsaved-badge');
    if (btn) { if (dirty) btn.classList.remove('disabled'); else btn.classList.add('disabled'); }
    if (badge) badge.style.display = dirty ? 'inline-flex' : 'none';
    updateStickyBar(dirty);
  };

  function getCurrentProfileValues() {
    var screenName = (document.getElementById('cpp-screen-name')?.value || '').trim();
    var hideName = document.getElementById('cpp-hide-name')?.checked || false;
    var bio = (document.getElementById('cpp-bio')?.value || '').trim();
    var links = {};
    MARKETPLACE_PLATFORMS.forEach(function(p) {
      var input = document.getElementById('cpp-link-' + p.key);
      if (input && input.value.trim()) links[p.key] = input.value.trim();
    });
    return { screen_name: screenName, hide_name: hideName, bio: bio, marketplace_links: links };
  }

  // Save profile
  window._cppSaveProfile = async function() {
    var btn = document.getElementById('cpp-profile-save');
    if (!btn || btn.classList.contains('disabled') || btn.classList.contains('saving')) return;
    var email = getEmail();
    if (!email) return;

    var current = getCurrentProfileValues();
    var fetchFn = window.mhvFetch || fetch;

    btn.textContent = 'Saving...';
    btn.classList.add('saving');

    try {
      // Clear previous errors
      panel.querySelectorAll('.cpp-input.error').forEach(function(el) { el.classList.remove('error'); });
      panel.querySelectorAll('.cpp-error-msg').forEach(function(el) { el.remove(); });

      // Screen name change? (optional — empty clears it)
      if (current.screen_name !== savedProfile.screen_name) {
        var snRes = await fetchFn(SERVER + '/update-screen-name-account', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_email: email, new_screen_name: current.screen_name }),
        });
        var snData = await snRes.json();
        if (!snData.success) {
          showFieldError('cpp-screen-name', snData.error || 'Failed to update screen name');
          btn.textContent = 'Save'; btn.classList.remove('saving');
          return;
        }
        savedProfile.screen_name = snData.screen_name;
        // Update the chat container data attribute so messages use new name
        var container = document.querySelector('.custom-chat-container');
        if (container) container.dataset.customerName = snData.screen_name;
      }

      // Public profile update (bio, hide_name, links)
      var ppRes = await fetchFn(SERVER + '/update-public-profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_email: email,
          hide_name: current.hide_name,
          bio: current.bio,
          marketplace_links: current.marketplace_links,
        }),
      });
      var ppData = await ppRes.json();

      if (ppData.success) {
        savedProfile.hide_name = ppData.hide_name;
        savedProfile.bio = ppData.bio;
        savedProfile.marketplace_links = ppData.marketplace_links;
        btn.textContent = 'Saved!';
        btn.classList.remove('saving');
        btn.classList.add('success');
        btn.classList.add('disabled');
        var badge = document.getElementById('cpp-unsaved-badge');
        if (badge) badge.style.display = 'none';
        hideStickyBar();
        setTimeout(function() { btn.textContent = 'Save'; btn.classList.remove('success'); }, 1500);
        showToast('Profile updated');
      } else {
        // Field-level error
        if (ppData.field) {
          var fieldId = ppData.field === 'bio' ? 'cpp-bio' : 'cpp-link-' + ppData.field;
          showFieldError(fieldId, ppData.error || 'Invalid value');
        } else {
          showToast(ppData.error || 'Failed to save');
        }
        btn.textContent = 'Save'; btn.classList.remove('saving');
      }
    } catch (err) {
      console.error('Chat profile save error:', err);
      showToast('Failed to save profile');
      btn.textContent = 'Save'; btn.classList.remove('saving');
    }
  };

  function showFieldError(inputId, msg) {
    var el = document.getElementById(inputId);
    if (!el) return;
    el.classList.add('error');
    var errDiv = document.createElement('div');
    errDiv.className = 'cpp-error-msg';
    errDiv.textContent = msg;
    el.parentNode.insertBefore(errDiv, el.nextSibling);
  }

  // --- PROFILE PIC TAB ---
  function renderPicTab(body) {
    var currentHtml =
      '<div class="cpp-current-pic">' +
        '<img src="' + esc(currentProfilePic || 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/profile-pic-mhv-happy.png?v=1765446700') + '" alt="Current">' +
        '<div>' +
          '<div class="cpp-current-pic-label">Current</div>' +
          '<div class="cpp-current-pic-name">' + esc(savedProfile.screen_name || 'You') + '</div>' +
        '</div>' +
      '</div>';

    var groupsHtml = AVATAR_GROUPS.map(function(group) {
      var picsHtml = group.pics.map(function(pic) {
        var selected = currentProfilePic === pic.url;
        return '<div class="cpp-pic-option' + (selected ? ' selected' : '') + '" ' +
          'data-url="' + esc(pic.url) + '" title="' + esc(pic.name) + '">' +
          '<img src="' + esc(pic.url) + '" alt="' + esc(pic.name) + '" loading="lazy">' +
        '</div>';
      }).join('');
      return '<div class="cpp-pic-group">' +
        '<div class="cpp-pic-group-title">' + esc(group.title) + '</div>' +
        '<div class="cpp-pic-grid">' + picsHtml + '</div>' +
      '</div>';
    }).join('');

    body.innerHTML = currentHtml + groupsHtml;

    // Click handlers
    body.querySelectorAll('.cpp-pic-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        selectPic(this.dataset.url);
      });
    });
  }

  async function selectPic(imageUrl) {
    var email = getEmail();
    if (!email) return;

    var fetchFn = window.mhvFetch || fetch;
    try {
      var res = await fetchFn(SERVER + '/update-profile-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_email: email, image_url: imageUrl }),
      });
      var data = await res.json();

      if (data.success) {
        currentProfilePic = imageUrl;
        // Update chat container data attribute so new messages use new pic
        var container = document.querySelector('.custom-chat-container');
        if (container) container.dataset.customerImage = imageUrl;
        showToast('Profile pic updated!');
        renderPicTab(panel.querySelector('#cpp-body'));
      } else {
        showToast(data.error || 'Failed to update pic');
      }
    } catch (err) {
      console.error('Chat profile pic error:', err);
      showToast('Failed to update pic');
    }
  }

  // --- SUBSCRIPTIONS TAB ---
  function renderSubsTab(body) {
    if (!marketingData) {
      body.innerHTML = '<p style="color:var(--mhv-text-subtle);text-align:center;padding:20px;">Loading...</p>';
      loadMarketingData(function() { if (activeTab === 'subs') renderSubsTab(body); });
      return;
    }

    var emailSub = marketingData.email || {};
    var smsSub = marketingData.sms || {};
    var notifs = marketingData.notifications || {};
    var smsSubscribed = !!smsSub.subscribed;
    var carrierOptedOut = !!smsSub.carrier_opted_out;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Marketing section
    var marketingHtml =
      '<div class="cpp-sub-section">' +
        '<div class="cpp-sub-section-title">Marketing</div>' +

        // Email marketing
        '<div class="cpp-sub-row">' +
          '<div class="cpp-sub-info">' +
            '<div class="cpp-sub-name">Email' +
              '<span class="cpp-status-badge ' + (emailSub.subscribed ? 'subscribed' : 'unsubscribed') + '">' +
                (emailSub.subscribed ? 'Subscribed' : 'Unsubscribed') +
              '</span>' +
            '</div>' +
          '</div>' +
          '<label class="cpp-toggle">' +
            '<input type="checkbox" ' + (emailSub.subscribed ? 'checked' : '') +
            ' onchange="window._cppToggleMarketing(\'email\', this.checked)">' +
            '<span class="cpp-toggle-slider"></span>' +
          '</label>' +
        '</div>' +

        // Text marketing (extra top margin for spacing)
        '<div class="cpp-sub-row" style="margin-top:4px;">' +
          '<div class="cpp-sub-info">' +
            '<div class="cpp-sub-name">Text' +
              '<span class="cpp-status-badge ' + (smsSub.subscribed ? 'subscribed' : 'unsubscribed') + '">' +
                (smsSub.subscribed ? 'Subscribed' : 'Unsubscribed') +
              '</span>' +
            '</div>' +
            (carrierOptedOut && !smsSub.subscribed ?
              '<div class="cpp-carrier-notice">' +
                (isMobile
                  ? 'You unsubscribed via text. <a href="sms:' + SMS_NUMBER_RAW + '?body=START">Tap here to text START</a> to re-subscribe.'
                  : 'You unsubscribed via text. Send <strong>START</strong> to <strong>' + SMS_NUMBER + '</strong> to re-subscribe.') +
              '</div>' : '') +
          '</div>' +
          '<label class="cpp-toggle">' +
            '<input type="checkbox" ' + (smsSub.subscribed ? 'checked' : '') +
            (carrierOptedOut && !smsSub.subscribed ? ' disabled' : '') +
            (!smsSub.has_phone ? ' disabled' : '') +
            ' onchange="window._cppToggleMarketing(\'sms\', this.checked)">' +
            '<span class="cpp-toggle-slider"></span>' +
          '</label>' +
        '</div>' +
      '</div>';

    // Absentee Bid notifications section
    var textDisabled = !smsSubscribed;
    var bidNotifHtml =
      '<div class="cpp-sub-section">' +
        '<div class="cpp-sub-section-title">Absentee Bid Notifications</div>' +

        // Bid Confirmation row
        '<div class="cpp-notif-row">' +
          '<div class="cpp-notif-label-col"><div class="cpp-notif-name">Bid Confirmation</div><div class="cpp-notif-desc">When you place or increase a bid</div></div>' +
          '<div class="cpp-notif-toggle-col">' +
            '<div class="cpp-notif-col-label">Email</div>' +
            '<label class="cpp-toggle"><input type="checkbox" ' +
              (notifs.bid_confirm_email ? 'checked' : '') +
              ' onchange="window._cppToggleNotif(\'bid_confirm_email\', this.checked)"><span class="cpp-toggle-slider"></span></label>' +
          '</div>' +
          '<div class="cpp-notif-toggle-col">' +
            '<div class="cpp-notif-col-label">Text</div>' +
            '<label class="cpp-toggle"><input type="checkbox" ' +
              (notifs.bid_confirm_text && !textDisabled ? 'checked' : '') +
              (textDisabled ? ' disabled' : '') +
              ' onchange="window._cppToggleNotif(\'bid_confirm_text\', this.checked)"><span class="cpp-toggle-slider"></span></label>' +
          '</div>' +
        '</div>' +

        // Outbid row
        '<div class="cpp-notif-row">' +
          '<div class="cpp-notif-label-col"><div class="cpp-notif-name">Outbid Alert</div><div class="cpp-notif-desc">When someone outbids you</div></div>' +
          '<div class="cpp-notif-toggle-col">' +
            '<div class="cpp-notif-col-label">Email</div>' +
            '<label class="cpp-toggle"><input type="checkbox" ' +
              (notifs.outbid_email ? 'checked' : '') +
              ' onchange="window._cppToggleNotif(\'outbid_email\', this.checked)"><span class="cpp-toggle-slider"></span></label>' +
          '</div>' +
          '<div class="cpp-notif-toggle-col">' +
            '<div class="cpp-notif-col-label">Text</div>' +
            '<label class="cpp-toggle"><input type="checkbox" ' +
              (notifs.outbid_text && !textDisabled ? 'checked' : '') +
              (textDisabled ? ' disabled' : '') +
              ' onchange="window._cppToggleNotif(\'outbid_text\', this.checked)"><span class="cpp-toggle-slider"></span></label>' +
          '</div>' +
        '</div>' +

        (textDisabled ? '<div style="font-size:11px;color:var(--mhv-text-subtle);margin-top:6px;">Subscribe to text messages above to enable text notifications.</div>' : '') +
      '</div>';

    var disclaimerHtml =
      '<div style="font-size:10px;color:var(--mhv-text-subtle);margin-top:16px;line-height:1.4;">' +
        'By subscribing to text messages, you agree to receive recurring automated marketing text messages from Granite Union Auction Company, LLC, including auction reminders, bidding alerts, and promotional offers. Consent is not a condition of purchase. Message frequency is approximately 2-5 messages per week. Msg &amp; data rates may apply. Reply HELP for help and STOP to cancel. See our <a href="/pages/terms-of-service" target="_blank" style="color:inherit;text-decoration:underline;">Terms of Service</a> and <a href="/pages/privacy-policy" target="_blank" style="color:inherit;text-decoration:underline;">Privacy Policy</a>.' +
      '</div>';

    body.innerHTML = marketingHtml + bidNotifHtml + disclaimerHtml;
  }

  // Toggle marketing subscription
  window._cppToggleMarketing = async function(type, subscribe) {
    var email = getEmail();
    if (!email) return;

    var payload = { customer_email: email };
    if (type === 'email') payload.email_marketing = subscribe;
    else payload.sms_marketing = subscribe;

    var fetchFn = window.mhvFetch || fetch;
    try {
      var res = await fetchFn(SERVER + '/update-marketing-preferences', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      var data = await res.json();
      if (data.success) {
        showToast((subscribe ? 'Subscribed to ' : 'Unsubscribed from ') + (type === 'email' ? 'email' : 'text'));
        // Reload marketing data and re-render
        loadMarketingData(function() { if (activeTab === 'subs') renderSubsTab(panel.querySelector('#cpp-body')); });
      } else {
        showToast(data.error || 'Failed to update');
        loadMarketingData(function() { if (activeTab === 'subs') renderSubsTab(panel.querySelector('#cpp-body')); });
      }
    } catch (err) {
      console.error('Chat profile marketing toggle error:', err);
      showToast('Failed to update subscription');
    }
  };

  // Toggle notification preference
  window._cppToggleNotif = async function(key, value) {
    var email = getEmail();
    if (!email) return;

    var payload = { customer_email: email };
    payload[key] = value;

    var fetchFn = window.mhvFetch || fetch;
    try {
      var res = await fetchFn(SERVER + '/update-notification-preferences', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      var data = await res.json();
      if (!data.success) {
        showToast('Failed to update preference');
        loadMarketingData(function() { if (activeTab === 'subs') renderSubsTab(panel.querySelector('#cpp-body')); });
      }
    } catch (err) {
      console.error('Chat profile notif toggle error:', err);
      showToast('Failed to update preference');
    }
  };

  // =========================================================================
  // OPEN / CLOSE
  // =========================================================================
  window.openChatProfilePanel = function() {
    var email = getEmail();
    if (!email) return; // guests can't open this

    var p = createPanel();
    if (!p) return;

    activeTab = 'profile';
    p.querySelectorAll('.cpp-tab').forEach(function(t) { t.classList.toggle('active', t.dataset.tab === 'profile'); });

    p.style.display = 'flex';
    lightboxOpen = true;
    previousHistoryState = window.history.state;
    window.history.pushState({ chatProfileLightboxOpen: true }, '');

    // Load data
    var body = p.querySelector('#cpp-body');
    body.innerHTML = '<p style="color:var(--mhv-text-subtle);text-align:center;padding:20px;">Loading...</p>';

    var profileLoaded = false, marketingLoaded = false;
    function checkDone() {
      if (profileLoaded && marketingLoaded) renderActiveTab();
    }

    loadProfileData(function() { profileLoaded = true; checkDone(); });
    loadMarketingData(function() { marketingLoaded = true; checkDone(); });
  };

  window.closeChatProfilePanel = function() {
    if (!panel || !lightboxOpen) return;
    panel.style.display = 'none';
    lightboxOpen = false;
    hideStickyBar();
    window.history.replaceState(previousHistoryState, '');
  };

  // Back button closes lightbox
  window.addEventListener('popstate', function() {
    if (lightboxOpen) {
      panel.style.display = 'none';
      lightboxOpen = false;
      hideStickyBar();
    }
  });

  // =========================================================================
  // STICKY SAVE BAR (bottom of viewport when dirty)
  // =========================================================================
  var stickyBar = null;

  function ensureStickyBar() {
    if (stickyBar) return stickyBar;
    stickyBar = document.createElement('div');
    stickyBar.className = 'cpp-sticky-bar';
    stickyBar.innerHTML =
      '<span class="cpp-sticky-label">You have unsaved profile changes</span>' +
      '<button class="cpp-sticky-save-btn" onclick="window._cppSaveProfile && _cppSaveProfile()">Save</button>';
    document.body.appendChild(stickyBar);
    return stickyBar;
  }

  function updateStickyBar(dirty) {
    if (!lightboxOpen || activeTab !== 'profile') {
      hideStickyBar();
      return;
    }
    if (dirty) {
      ensureStickyBar();
      stickyBar.classList.add('visible');
    } else {
      hideStickyBar();
    }
  }

  function hideStickyBar() {
    if (stickyBar) stickyBar.classList.remove('visible');
  }

  // =========================================================================
  // INTERCEPT OWN PROFILE CLICKS → open editor instead of read-only lightbox
  // =========================================================================
  function getOwnCustomerId() {
    var c = document.querySelector('.custom-chat-container');
    return c ? c.dataset.customerId : '';
  }

  function getOwnBidderNumber() {
    var c = document.querySelector('.custom-chat-container');
    return c ? (c.dataset.customerBidderNumber || '') : '';
  }

  // Wait for profile-lightbox.js to load, then wrap openProfileLightbox
  var _wrapInterval = setInterval(function() {
    if (window.openProfileLightbox && !window._cppWrappedProfileLightbox) {
      var originalOpen = window.openProfileLightbox;
      window.openProfileLightbox = function(customerId, preloadData) {
        var ownId = getOwnCustomerId();
        if (ownId && customerId && String(customerId) === String(ownId)) {
          openChatProfilePanel();
          return;
        }
        originalOpen(customerId, preloadData);
      };

      // Same courtesy for the bidder-number path. Public surfaces open profiles by
      // bidder number now that customer ids are no longer broadcast (Q28), and
      // tapping your OWN row should still open your editable panel rather than the
      // read-only lightbox. Guarded on openProfileLightboxByBidder existing so an
      // older cached profile-lightbox.js can't break the wrapper.
      if (window.openProfileLightboxByBidder) {
        var originalOpenByBidder = window.openProfileLightboxByBidder;
        window.openProfileLightboxByBidder = function(bidderNumber, preloadData) {
          var ownBidder = getOwnBidderNumber();
          if (ownBidder && bidderNumber && String(bidderNumber) === String(ownBidder)) {
            openChatProfilePanel();
            return;
          }
          originalOpenByBidder(bidderNumber, preloadData);
        };
      }

      window._cppWrappedProfileLightbox = true;
      clearInterval(_wrapInterval);
    }
  }, 200);
  // Stop trying after 10 seconds
  setTimeout(function() { clearInterval(_wrapInterval); }, 10000);

})();
